import { render, staticRenderFns } from "./customerRepurchaseItemTag.vue?vue&type=template&id=0cdd8cd8&scoped=true"
import script from "./customerRepurchaseItemTag.vue?vue&type=script&lang=js"
export * from "./customerRepurchaseItemTag.vue?vue&type=script&lang=js"
import style0 from "./customerRepurchaseItemTag.vue?vue&type=style&index=0&id=0cdd8cd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdd8cd8",
  null
  
)

export default component.exports